import React, { useState } from "react";
import "../../assets/styles/local/ProjectKanBan.css";
import DownArrow from "../../assets/icons/downarrow.svg";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import xIcon from "../../assets/icons/x-circle.svg";
import {
  ChangeProjectIndex,
  FetchProjectKanBan,
  FetchProjectsWeekly,
  ProjectGrouping,
  UpdateProjectStatus,
  FetchProjectByWeeks,
} from "../../redux/actions/action";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import Header from "../../layouts/Header";

const ProjectKanBan = ({ query2 }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [query, setQuery] = useState("");
  const [allTasks, setAllTasks] = useState([]);
  const [weekData, setWeekData] = useState([]);
  const [openWeeks, setOpenWeeks] = useState([]);
  const [isAlertOpen, setIsAlertOpen] = useState(true);
  const [matchingResults, setMatchingResults] = useState({
    weekly: true, // Default to true or false based on your initial condition
    general: true, // Default to true or false based on your initial condition
  });
  const [projectListTranslation, setProjectListTranslation] = useState({});
  const t = (key) => projectListTranslation?.[key] || "";
  // console.log("datakan",projectListTranslation);

  const companyId = window.localStorage.getItem("companyid");
  const fetchProjectKanBanResponse = useSelector(
    (state) => state.user.fetchProjectKanBan,
  );
  const projectGrouping = useSelector((state) => state.user.projectGrouping);
  const fetchProjectsByWeeksRes = useSelector(
    (state) => state.user.fetchProjectsByWeeksRes,
  );
  const fetchProjectWeekly = useSelector(
    (state) => state.user.fetchProjectWeekly,
  );

  useEffect(() => {
    if (companyId) {
      dispatch(FetchProjectKanBan(companyId, query));
    }
  }, [companyId, query]);

  useEffect(() => {
    if (fetchProjectKanBanResponse?.status === true) {
      setAllTasks(fetchProjectKanBanResponse?.data[0]?.projectstatus);
    }
  }, [fetchProjectKanBanResponse]);

  useEffect(() => {
    if (projectGrouping?.status === true) {
      setWeekData(projectGrouping?.data);
      if (projectGrouping?.data && projectGrouping?.data.length > 0) {
        let lastElement = projectGrouping.data[projectGrouping.data.length - 1];
        setOpenWeeks([lastElement.weekNumber]);
        dispatch(FetchProjectsWeekly(lastElement.weekNumber));
      }
    }
  }, [projectGrouping]);

  // new for archived column start.
  const [archivedTasks, setArchivedTasks] = useState([]);
  useEffect(() => {
    // dispatch(FetchProjectByWeeks());
  }, []);

  useEffect(() => {
    if (fetchProjectsByWeeksRes?.status === true) {
      setArchivedTasks(fetchProjectsByWeeksRes?.data[0]?.projectstatus);
    }
  }, [fetchProjectsByWeeksRes]);
  // new for archived column end.

  useEffect(() => {
    dispatch(ProjectGrouping());
    fetchScreenTranslations("Project-List").then((res) => {
      setProjectListTranslation(res);
    });
  }, []);

  const [fetchWeeklyData, setFetchWeeklyData] = useState([]);

  useEffect(() => {
    if (fetchProjectWeekly?.status === true) {
      setFetchWeeklyData(fetchProjectWeekly?.data);
    }
  }, [fetchProjectWeekly]);

  const onDragEnd = async (result, columns, setColumns) => {
    if (!result.destination) return;
    const { source, destination } = result;
    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.projectdetails];
      const destItems = [...destColumn.projectdetails];

      if (destination.droppableId === "5") {
        const tempWeeklyData = [...fetchWeeklyData];
        const [removed] = sourceItems.splice(source.index, 1);
        tempWeeklyData.splice(destination.index, 0, removed);
        setColumns({
          ...columns,
          [source.droppableId]: {
            ...sourceColumn,
            projectdetails: sourceItems,
          },
        });
        setFetchWeeklyData([...tempWeeklyData]);
        setTimeout(async () => {
          await ChangeProjectIndex(
            companyId,
            result.draggableId,
            destColumn.statusid,
            result.source.index + 1,
            result.destination.index + 1,
            true,
          );
          await UpdateProjectStatus(removed.projectid, destColumn.statusid);
        }, 1500);
      } else if (source.droppableId === "5") {
        const tempWeeklyData = [...fetchWeeklyData];
        const [removed] = tempWeeklyData.splice(source.index, 1);
        destItems.splice(destination.index, 0, removed);
        setColumns({
          ...columns,
          [destination.droppableId]: {
            ...destColumn,
            projectdetails: destItems,
          },
        });
        setFetchWeeklyData([...tempWeeklyData]);
        setTimeout(async () => {
          await ChangeProjectIndex(
            companyId,
            result.draggableId,
            destColumn.statusid,
            result.source.index + 1,
            result.destination.index + 1,
            true,
          );
          await UpdateProjectStatus(removed.projectid, destColumn.statusid);
        }, 1500);
      } else {
        const [removed] = sourceItems.splice(source.index, 1);
        destItems.splice(destination.index, 0, removed);
        setColumns({
          ...columns,
          [source.droppableId]: {
            ...sourceColumn,
            projectdetails: sourceItems,
          },
          [destination.droppableId]: {
            ...destColumn,
            projectdetails: destItems,
          },
        });
        setTimeout(async () => {
          await ChangeProjectIndex(
            companyId,
            result.draggableId,
            destColumn.statusid,
            result.source.index + 1,
            result.destination.index + 1,
            true,
          );
          await UpdateProjectStatus(removed.projectid, destColumn.statusid);
        }, 1500);
      }
    } else {
      const column = columns[source.droppableId];
      const copiedItems = [...column.projectdetails];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...column,
          projectdetails: copiedItems,
        },
      });
      await ChangeProjectIndex(
        companyId,
        result.draggableId,
        column.statusid,
        source.index + 1,
        destination.index + 1,
      );
      await UpdateProjectStatus(removed.projectid, column.statusid);
    }
  };

  const getBackgroundColor = (statusid) => {
    switch (statusid) {
      case process.env.REACT_APP_PROJECT_INFO_REQUEST:
      case process.env.REACT_APP_PROJECT_QUOTE_REQUEST:
      case process.env.REACT_APP_PROJECT_QUOTED:
        return "#D2DCE9";
      case process.env.REACT_APP_PROJECT_WON_PROJECT:
        return "#95A7C6";
      case process.env.REACT_APP_PROJECT_FOR_PODUCTION:
        return "#00246A";
      default:
        return "#EAEAEA";
    }
  };
  const statusTranslationMap = {
    [process.env.REACT_APP_PROJECT_INFO_REQUEST]: t("Info Request"),
    [process.env.REACT_APP_PROJECT_QUOTE_REQUEST]: t("Quote Request"),
    [process.env.REACT_APP_PROJECT_QUOTED]: t("Quoted"),
    [process.env.REACT_APP_PROJECT_WON_PROJECT]: t("WON PROJECTS"),
    [process.env.REACT_APP_PROJECT_FOR_PODUCTION]: t("FOR PRODUCTION"),
    [process.env.REACT_APP_PROJECT_ARCHIVED]: t("ARCHIVED"),
  };

  useEffect(() => {
    // Check for matching results in fetchWeeklyData
    if (fetchWeeklyData.length > 0) {
      const hasMatchWeekly = fetchWeeklyData.some((task) => {
        const projectNameMatch = task.projectname
          .toLowerCase()
          .includes(query.toLowerCase());
        const clientNameMatch = task?.clientname
          ?.toLowerCase()
          .includes(query.toLowerCase());
        return projectNameMatch || clientNameMatch;
      });
      setMatchingResults((prevResults) => ({
        ...prevResults,
        weekly: hasMatchWeekly,
      }));
      if (!hasMatchWeekly) {
        setIsAlertOpen(false);
        setTimeout(() => {
          setIsAlertOpen(true);
        }, 1000);
      }
    } else {
      setMatchingResults((prevResults) => ({
        ...prevResults,
        weekly: false,
      }));
      setIsAlertOpen(false);
      setTimeout(() => {
        setIsAlertOpen(true);
      }, 1000);
    }

    // Check for matching results in allTasks
    if (allTasks.length > 0) {
      const hasMatch = allTasks.some((column) =>
        column.projectdetails.some((task) => {
          const projectNameMatch = task.projectname
            .toLowerCase()
            .includes(query.toLowerCase());
          const clientNameMatch = task?.clientname
            ?.toLowerCase()
            .includes(query.toLowerCase());
          return projectNameMatch || clientNameMatch;
        }),
      );
      setMatchingResults((prevResults) => ({
        ...prevResults,
        general: hasMatch,
      }));
      if (!hasMatch) {
        setIsAlertOpen(false);
        setTimeout(() => {
          setIsAlertOpen(true);
        }, 1000);
      }
    } else {
      setMatchingResults((prevResults) => ({
        ...prevResults,
        general: false,
      }));
      setIsAlertOpen(false);
      setTimeout(() => {
        setIsAlertOpen(true);
      }, 1000);
    }
  }, [query, fetchWeeklyData, allTasks]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsAlertOpen(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [query]);

  //functionality of radio button show color
  const getPriorityColor = (priorityid) => {
    switch (priorityid) {
      case "08da8a3e-d43a-40b9-845d-ba8c2e749692":
        return "green"; // High priority
      case "08da8a3e-d43a-40b9-845d-ba8c2e749693":
        return "yellow"; // Low priority
      case "08da8a3e-d43a-40b9-845d-ba8c2e749694":
        return "orange"; // Medium priority
      default:
        return ""; // Default priority
    }
  };

  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div
            style={{
              color: "#333333",
              fontSize: "16px",
              lineHeight: "27px",
              fontWeight: "bold",
            }}
          >
            {/* Projects */}
            {/* {projectListTranslation[8]?.translation} */}
          </div>
        }
      />

      <div className="wrapper p-4">
        <DragDropContext
          onDragEnd={(result) => onDragEnd(result, allTasks, setAllTasks)}
        >
          {Object.entries(allTasks)?.map(([columnId, column], index) => {
            return (
              <Droppable droppableId={columnId} key={`droppable-${index}`}>
                {(provided, snapshot) => {
                  return (
                    <div
                      className="sub-wrapper"
                      key={`droppable-div-${columnId}`}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      <div className="project-title">
                        {statusTranslationMap[column.statusid] ||
                          "" ||
                          column.statusname}
                      </div>
                      {column.statusid !==
                        process.env.REACT_APP_PROJECT_ARCHIVED && (
                        <div className="project-items-scroll">
                          {column?.projectdetails
                            ?.filter((task) => {
                              const projectNameMatch = task.projectname
                                .toLowerCase()
                                .includes(query.toLowerCase());
                              const clientNameMatch = task?.clientname
                                ?.toLowerCase()
                                .includes(query.toLowerCase());
                              return projectNameMatch || clientNameMatch;
                            })
                            .map((task, index) => {
                              const getInitials = (fullName) => {
                                const nameArray = fullName.split(" ");
                                const firstNameInitial =
                                  nameArray[0]?.[0]?.toUpperCase();
                                const lastNameInitial =
                                  nameArray[1]?.[0]?.toUpperCase();

                                return `${firstNameInitial}${lastNameInitial}`;
                              };

                              const projectManagerInitials =
                                task.projectmanagername
                                  ? getInitials(task.projectmanagername)
                                  : "";

                              return (
                                <Draggable
                                  key={`draggable-${task.projectid}-${index}`}
                                  draggableId={`${task.projectid}`}
                                  index={index}
                                >
                                  {(provided, snapshot) => {
                                    return (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className="item-wrapper"
                                        onClick={() => {
                                          window.localStorage.setItem(
                                            "projectid",
                                            task.projectid,
                                          );
                                          history.push(
                                            `/project/${task.projectid}`,
                                          );
                                        }}
                                      >
                                        <div
                                          className="sub-item-wrp"
                                          style={{
                                            // backgroundColor: getBackgroundColor(
                                            //   column.statusid
                                            // ),
                                            backgroundColor: "grey",
                                          }}
                                        ></div>
                                        <div className="item-content-wrp">
                                          <div className="item-content">
                                            <div className="project-name-hide project-name">
                                              {task.projectname}
                                            </div>
                                            <div className="project-name-hide project-sub-name">
                                              {task?.clientname}
                                            </div>
                                          </div>

                                          <div
                                            style={{
                                              width: "5px",
                                              height: "34px",
                                              borderRadius: "10px",
                                              backgroundColor: getPriorityColor(
                                                task.priorityid,
                                              ),
                                            }}
                                          ></div>

                                          <div className="avatar position-relative">
                                            {task.projectmanagerimage ? (
                                              <img
                                                alt=""
                                                src={task.projectmanagerimage}
                                                height="32px"
                                                width="32px"
                                                className="item-img "
                                              />
                                            ) : task.projectmanagername ? (
                                              <div className="item-img">
                                                <div>
                                                  {projectManagerInitials}
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="item-img-remove"></div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }}
                                </Draggable>
                              );
                            })}
                          {provided.placeholder}
                        </div>
                      )}

                      {/* Archived */}
                      {column.statusid ===
                        process.env.REACT_APP_PROJECT_ARCHIVED && (
                        <div className="project-items-scroll">
                          {weekData.map((item, index) => {
                            const isOpen = openWeeks.includes(item.weekNumber);
                            return (
                              <React.Fragment key={`weekdata-${index}`}>
                                <div
                                  className="week-data-main"
                                  onClick={() => {
                                    if (isOpen) {
                                      setOpenWeeks((prevWeeks) =>
                                        prevWeeks.filter(
                                          (openWeek) =>
                                            openWeek !== item.weekNumber,
                                        ),
                                      );
                                    } else {
                                      setOpenWeeks((prevWeeks) => [
                                        ...prevWeeks,
                                        item.weekNumber,
                                      ]);
                                      dispatch(
                                        FetchProjectsWeekly(item.weekNumber),
                                      );
                                    }
                                  }}
                                >
                                  <div className="item-wrapper week-wrapper">
                                    <div className="week-title">
                                      Week {item.weekNumber}
                                    </div>
                                    <span className="week-label">
                                      <img
                                        alt=""
                                        src={DownArrow}
                                        className={`ms-5 cursor-pointer ${
                                          isOpen ? "downarrow" : "uparrow"
                                        }`}
                                      />
                                    </span>
                                  </div>
                                  {isOpen && (
                                    <div className="week-data-main-wrp">
                                      {fetchWeeklyData
                                        ?.filter((task) => {
                                          const projectNameMatch =
                                            task.projectname
                                              .toLowerCase()
                                              .includes(query.toLowerCase());
                                          const clientNameMatch =
                                            task?.clientname
                                              ?.toLowerCase()
                                              .includes(query.toLowerCase());
                                          return (
                                            projectNameMatch || clientNameMatch
                                          );
                                        })
                                        .map((task, index) => {
                                          const getInitial = (fullName) => {
                                            const nameArray =
                                              fullName.split(" ");
                                            const firstNameInitial =
                                              nameArray[0]?.[0]?.toUpperCase();
                                            const lastNameInitial =
                                              nameArray[1]?.[0]?.toUpperCase();

                                            return `${firstNameInitial}${lastNameInitial}`;
                                          };

                                          const projectManagerInitial =
                                            task.projectmanagername
                                              ? getInitial(
                                                  task.projectmanagername,
                                                )
                                              : "";

                                          return (
                                            <Draggable
                                              key={`draggable-${task.projectid}`}
                                              draggableId={task.projectid}
                                              index={index}
                                            >
                                              {(provided, snapshot) => {
                                                return (
                                                  <div
                                                    className="item-wrapper"
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    onClick={() => {
                                                      window.localStorage.setItem(
                                                        "projectid",
                                                        task.projectid,
                                                      );
                                                      history.push(
                                                        `/project/${task.projectid}`,
                                                      );
                                                    }}
                                                  >
                                                    <div
                                                      className="sub-item-wrp"
                                                      style={{
                                                        backgroundColor:
                                                          "#EAEAEA",
                                                      }}
                                                    ></div>
                                                    <div className="item-content-wrp">
                                                      <div className="item-content">
                                                        <div className="project-name-hide project-name">
                                                          {task.projectname}
                                                        </div>
                                                        <div className="project-name-hide project-sub-name">
                                                          {task?.clientname}
                                                        </div>
                                                      </div>
                                                      <div className="avatar position-relative">
                                                        {task.projectmanagerimage ? (
                                                          <img
                                                            alt=""
                                                            src={
                                                              task.projectmanagerimage
                                                            }
                                                            height="32px"
                                                            width="32px"
                                                            className="item-img "
                                                          />
                                                        ) : task.projectmanagername ? (
                                                          <div className="item-img">
                                                            <div>
                                                              {
                                                                projectManagerInitial
                                                              }
                                                            </div>
                                                          </div>
                                                        ) : (
                                                          <div className="item-img-remove"></div>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              }}
                                            </Draggable>
                                          );
                                        })}
                                      {provided.placeholder}
                                    </div>
                                  )}
                                </div>
                              </React.Fragment>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                }}
              </Droppable>
            );
          })}
        </DragDropContext>
        {isAlertOpen &&
        !(matchingResults.weekly || matchingResults.general) &&
        allTasks.length > 0 ? (
          <div className="alert-box">
            <div className="alert-title">
              No results were found. Try to refine your search.
            </div>
            <div className="alert-img">
              <img
                alt=""
                className="alert-x-icon-pop"
                src={xIcon}
                onClick={() => {
                  setIsAlertOpen(false);
                }}
              />
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ProjectKanBan;
